import Joi from 'joi';

import { AppSubjectEnum } from '../../../../shared/modules/authz/enums/app-subject.enum';
import { updateLocationContactSchema } from '../../../contacts/validators/schemas/update-location-contact.schema';
import { createPoliciesAssignSchema } from '../../../policies/validators/schemas/policies-assign.schema';
import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';
import { LocationTypeEnum } from '../../enums/location-type.enum';

/**
 * Schema for existing location record update validation.
 */
export const updateLocationSchema = () =>
  Joi.object({
    // id - Required and must not be null
    id: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|location-id|cannot-be-null',
      }),
      otherwise: Joi.number().required().messages({
        'any.required': 'validations|location-id|required',
        'number.base': 'validations|location-id|must-be-string',
        'string.empty': 'validations|location-id|must-not-be-empty',
      }),
    }),
    // Code - Required and cannot be null
    code: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|location-code|cannot-be-null',
      }),
      otherwise: Joi.string().required().messages({
        'any.required': 'validations|location-code|required',
        'string.base': 'validations|location-code|must-be-string',
        'string.empty': 'validations|location-code|must-not-be-empty',
      }),
    }),
    // Name - Required and cannot be null
    name: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|location-name|cannot-be-null',
      }),
      otherwise: Joi.string().required().messages({
        'any.required': 'validations|location-name|required',
        'string.base': 'validations|location-name|must-be-string',
        'string.empty': 'validations|location-name|must-not-be-empty',
      }),
    }),

    type: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|location-type|cannot-be-null',
      }),
      otherwise: Joi.string()
        .valid(...Object.values(LocationTypeEnum))
        .required()
        .messages({
          'any.required': 'validations|location-type|required',
          'any.only': 'validations|location-type|invalid-value',
          'string.base': 'validations|location-type|must-be-string',
        }),
    }),
    // Contact - Optional
    contact: updateLocationContactSchema(), // Reuse the schema for updating contact

    // Tags - Optional
    tags: createTagsSchema().messages({
      'array.base': 'validations|location-tags|invalid-value',
    }),

    // Policies
    policies: createPoliciesAssignSchema(AppSubjectEnum.LOCATION),

    // Pickup / dropoff / private flags (optional on update; null treated as unset)
    isPickUp: Joi.boolean().optional().empty(null),
    isDropOff: Joi.boolean().optional().empty(null),
    isPrivate: Joi.boolean().optional().empty(null),

    // Files - Optional (no validation applied)
    files: Joi.any().optional(),
  })
    // Ignore extra fields
    .unknown();
